<template>
  <standard-dialog
    v-model="model"
    :title="isEditing ? $t('edit_supplier') : $t('add_supplier')"
    icon="mdi-truck"
    :save-text="$t('save')"
    :loading="loading"
    @save="save"
  >
    <v-form ref="form">
      <text-field
        v-model="supplier.name"
        :label="$t('warehouse.supplier_name')"
        :rules="[rules.required]"
      />
      <text-field
        v-model="supplier.address"
        :label="$t('address')"
        kind="address"
        :rules="[rules.required]"
      />
      <text-field
        v-model="supplier.city"
        :label="$t('city')"
        kind="address"
        :rules="[rules.required]"
      />
      <v-row>
        <v-col cols="6" class="py-0">
          <text-field
            v-model="supplier.phone"
            :label="$t('phone_no')"
            kind="phone"
            placeholder="+387 61 234 567"
            :hint="$t('phone_format_hint')"
            persistent-hint
            :rules="[rules.required, rules.phone]"
          />
        </v-col>
        <v-col cols="6" class="py-0">
          <text-field
            v-model="supplier.email"
            :label="$t('email')"
            kind="email"
            :rules="[rules.required, rules.email]"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="py-0">
          <text-field
            v-model="supplier.jib"
            :label="$t('jib')"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="6" class="py-0">
          <text-field
            v-model="supplier.pib"
            :label="$t('pib')"
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>
      <text-field
        v-model="supplier.contact_person"
        :label="$t('warehouse.contact_person')"
        :rules="[rules.required]"
        kind="user"
      />
      <text-area
        v-model="supplier.note"
        :label="$t('note')"
        :rows="3"
        :rules="[rules.required]"
      />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import { supplier } from "@/models/warehouse";
import warehouseService from "@/services/warehouse";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  components: {
    StandardDialog,
  },
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    editedSupplier: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    supplier: { ...supplier },
    loading: false,
  }),
  computed: {
    isEditing() {
      return this.editedSupplier && this.editedSupplier.id;
    },
  },
  watch: {
    model(val) {
      if (val) {
        if (this.editedSupplier) {
          this.supplier = { ...this.editedSupplier };
        } else {
          this.supplier = { ...supplier };
        }
        // Reset validation when dialog opens
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      }
    },
  },
  methods: {
    save() {
      this.loading = true;
      const promise = this.isEditing
        ? warehouseService.updateSupplier(this.supplier.id, this.supplier)
        : warehouseService.createSupplier(this.supplier);

      promise
        .then((response) => {
          const messageKey = this.isEditing
            ? "supplier_updated_success"
            : "supplier_added_success";
          this.showSuccessSnackbar(this.$t(messageKey));
          this.$emit("saved");
          if (!this.isEditing) {
            this.$emit("supplierAdded", response.data);
          }
          this.model = false;
        })
        .catch(() => {
          const errorKey = this.isEditing
            ? "supplier_updated_error"
            : "supplier_added_error";
          this.showErrorSnackbar(this.$t(errorKey));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
